import axios from "axios";
import { MAIN_URL } from "../Configurations/Urls";

function authHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchClientsForOrgAppAccess() {
  const res = await axios.get(`${MAIN_URL}/api/client-management/clients/data`, {
    headers: authHeaders(),
  });
  return res?.data?.data || [];
}

export async function fetchOrgAppAccessContext(clientId) {
  const res = await axios.get(
    `${MAIN_URL}/api/client-management/clients/${clientId}/applications`,
    { headers: authHeaders() }
  );
  return res.data;
}

export async function deactivateOrganizationApplication(clientId, payload) {
  const res = await axios.patch(
    `${MAIN_URL}/api/client-management/clients/${clientId}/deactivate-organization-application`,
    payload,
    { headers: authHeaders() }
  );
  return res.data;
}

export async function reactivateOrganizationApplication(clientId, payload) {
  const res = await axios.patch(
    `${MAIN_URL}/api/client-management/clients/${clientId}/reactivate-organization-application`,
    payload,
    { headers: authHeaders() }
  );
  return res.data;
}

export async function assignApplicationToOrganization(clientId, payload) {
  const res = await axios.post(
    `${MAIN_URL}/api/client-management/clients/${clientId}/assign-organization-application`,
    payload,
    { headers: authHeaders() }
  );
  return res.data;
}
